var map = {
	"./Base": 206,
	"./Base/": 206,
	"./Base/config": 854,
	"./Base/config.js": 854,
	"./Base/index": 206,
	"./Base/index.js": 206,
	"./Base/style": 178,
	"./Base/style.js": 178,
	"./Clutch": 501,
	"./Clutch/": 501,
	"./Clutch/index": 501,
	"./Clutch/index.js": 501,
	"./Clutch/style": 1141,
	"./Clutch/style.js": 1141,
	"./NewUi": 502,
	"./NewUi/": 502,
	"./NewUi/index": 502,
	"./NewUi/index.js": 502,
	"./NewUi/style": 1142,
	"./NewUi/style.js": 1142,
	"./OldUi": 503,
	"./OldUi/": 503,
	"./OldUi/index": 503,
	"./OldUi/index.js": 503,
	"./OldUi/style": 1143,
	"./OldUi/style.js": 1143,
	"./SpireonNew": 504,
	"./SpireonNew/": 504,
	"./SpireonNew/index": 504,
	"./SpireonNew/index.js": 504,
	"./SpireonNew/style": 1144,
	"./SpireonNew/style.js": 1144,
	"./SpireonOld": 505,
	"./SpireonOld/": 505,
	"./SpireonOld/index": 505,
	"./SpireonOld/index.js": 505,
	"./SpireonOld/style": 1145,
	"./SpireonOld/style.js": 1145
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1936;
module.exports = webpackAsyncContext;